function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** drag 事件节流目标帧率 */
const DRAG_FPS = 10;
const DRAG_FRAME_MS = 1000 / DRAG_FPS;
export class WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope) {
    _defineProperty(this, "modelGetter", void 0);
    _defineProperty(this, "scope", void 0);
    _defineProperty(this, "tool", void 0);
    _defineProperty(this, "shadowEmitter", void 0);
    _defineProperty(this, "enableToolEvent", void 0);
    _defineProperty(this, "eventAvailable", false);
    _defineProperty(this, "lastDragTime", 0);
    _defineProperty(this, "dragRafId", 0);
    _defineProperty(this, "pendingDragEvent", null);
    _defineProperty(this, "onMouseDownSelf", event => {
      this.eventAvailable = this.enableToolEvent();
      if (!this.eventAvailable) {
        return;
      }
      this.lastDragTime = 0;
      if (this.dragRafId) {
        cancelAnimationFrame(this.dragRafId);
        this.dragRafId = 0;
      }
      this.pendingDragEvent = null;
      this.shadowEmitter.setActive(true);
      try {
        this.onMouseDown(event);
      } catch (error) {
        this.cancelCurrentAction();
        this.eventAvailable = false;
        this.shadowEmitter.setActive(false);
        throw error;
      }
    });
    _defineProperty(this, "flushPendingDrag", () => {
      this.dragRafId = 0;
      if (this.pendingDragEvent) {
        this.lastDragTime = performance.now();
        const event = this.pendingDragEvent;
        this.pendingDragEvent = null;
        try {
          this.onMouseDrag(event);
        } catch (error) {
          this.cancelCurrentAction();
          this.eventAvailable = false;
          this.shadowEmitter.setActive(false);
          throw error;
        }
      }
    });
    _defineProperty(this, "onMouseDragSelf", event => {
      if (!this.eventAvailable) {
        return;
      }
      const now = performance.now();
      if (now - this.lastDragTime >= DRAG_FRAME_MS) {
        this.lastDragTime = now;
        this.pendingDragEvent = null;
        try {
          this.onMouseDrag(event);
        } catch (error) {
          this.cancelCurrentAction();
          this.eventAvailable = false;
          this.shadowEmitter.setActive(false);
          throw error;
        }
      } else {
        // 暂存最后一个 event，rAF 保证触发
        this.pendingDragEvent = event;
        if (!this.dragRafId) {
          this.dragRafId = requestAnimationFrame(this.flushPendingDrag);
        }
      }
    });
    _defineProperty(this, "onMouseUpSelf", event => {
      if (!this.eventAvailable) {
        return;
      }
      if (this.dragRafId) {
        cancelAnimationFrame(this.dragRafId);
        this.dragRafId = 0;
      }
      if (this.pendingDragEvent) {
        try {
          this.onMouseDrag(this.pendingDragEvent);
          this.pendingDragEvent = null;
        } catch (error) {
          this.pendingDragEvent = null;
          this.cancelCurrentAction();
          this.eventAvailable = false;
          this.shadowEmitter.setActive(false);
          throw error;
        }
      }
      try {
        this.onMouseUp(event);
      } catch (error) {
        this.cancelCurrentAction();
        this.eventAvailable = false;
        throw error;
      } finally {
        this.shadowEmitter.setActive(false);
      }
    });
    this.modelGetter = modelGetter;
    this.enableToolEvent = enableToolEvent;
    this.scope = scope;
    this.shadowEmitter = shadowEmitter;
    this.tool = new scope.Tool();
    this.tool.onMouseDown = this.onMouseDownSelf;
    this.tool.onMouseDrag = this.onMouseDragSelf;
    this.tool.onMouseUp = this.onMouseUpSelf;
  }
  cancelCurrentAction() {}
}